module.exports = __webpack_public_path__ + "media/src/images/icons/refresh/black-628d32b8dd5c8cd3d9017beae857bcac.svg";